import React from 'react';

import Reservation2 from 'app/components/icons/Reservation2';
import ReservationDetail, {
  ReservationDetailProps,
} from 'app/components/ReservationSummary/ReservationDetail';
import TextLabel from 'app/components/ReservationSummary/TextLabel';
import { time } from 'app/services/ReservationHelper';

export type ReservationDetailTimeProps = Omit<ReservationDetailProps, 'Icon'> & {
  dateTime: string | undefined;
  ianaTimezone: string | undefined;
  isMuted?: boolean;
};

export default function ReservationDetailTime({
  dateTime,
  ianaTimezone,
  isMuted = false,
  ...props
}: ReservationDetailTimeProps) {
  const $time = dateTime ? time(dateTime, ianaTimezone) : null;

  return (
    <ReservationDetail Icon={Reservation2} testID="ReservationDetailTime" {...props}>
      <TextLabel isMuted={isMuted}>{$time ? $time.format('hh:mm') : ''}</TextLabel>
      <TextLabel isMuted={isMuted}>{$time ? $time.format('A z') : ''}</TextLabel>
    </ReservationDetail>
  );
}
